import { render, staticRenderFns } from "./TomatoSimulator.vue?vue&type=template&id=0d5352c6&scoped=true"
import script from "./TomatoSimulator.vue?vue&type=script&lang=js"
export * from "./TomatoSimulator.vue?vue&type=script&lang=js"
import style0 from "./TomatoSimulator.vue?vue&type=style&index=0&id=0d5352c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5352c6",
  null
  
)

export default component.exports